export const COLUMNS = [
  { key: 'index', label: '#', width: '2%', align: 'center' as const },
  { key: 'thumbnail', label: '縮圖', width: '12%', minWidth: 150, align: 'center' as const },
  { key: 'info', label: '影片資訊', width: '25%', minWidth: 150, align: 'left' as const },
  { key: 'checkpoints', label: 'CheckPoints', width: '15%', minWidth: 160, align: 'left' as const },
  { key: 'tags', label: 'Tag', width: '200px', maxWidth: '200px', minWidth: 200, align: 'center' as const },
  { key: 'zones', label: '區域', width: '10%', minWidth: 120, align: 'center' as const },
  { key: 'groups', label: '群組', width: '200px', minWidth: 200, align: 'center' as const },
  { key: 'delete', label: '刪除', width: '5%', align: 'center' as const },
  { key: 'share', label: '分享', width: '5%', align: 'center' as const },
];

export const PAGE_COLUMN_KEYS: Record<string, string[]> = {
  myPoint: ['index', 'thumbnail', 'info', 'checkpoints', 'tags', 'zones', 'groups'],
  myPersonalFavorite: ['index', 'thumbnail', 'info', 'checkpoints', 'tags', 'zones', 'groups'],
  mediaPoint: ['index', 'thumbnail', 'info', 'checkpoints', 'tags', 'zones', 'groups'],
  teamPoint: ['index', 'thumbnail', 'info', 'checkpoints', 'tags', 'groups'],
  acopy: ['index', 'thumbnail', 'info', 'checkpoints', 'tags', 'zones', 'groups'],
  community: ['index', 'thumbnail', 'info', 'checkpoints', 'tags', 'zones', 'groups'],
  following: ['index', 'thumbnail', 'info', 'checkpoints', 'tags', 'zones', 'groups'],
  groupPage: ['index', 'thumbnail', 'info', 'checkpoints', 'tags', 'zones', 'groups'], // 新增 groupPage 的設定
}; 